import type { App, DirectiveBinding, Plugin } from 'vue'
import { sanitizeUrl } from '@braintree/sanitize-url'

/**
 * @deprecated call `sanitizeUrl` instead
 * @param url
 */
export function useSafeHref(url: string): string {
  return sanitizeUrl(url)
}

/**
 * @deprecated call `sanitizeUrl` instead
 */
export const vueSafeHrefPlugin: Plugin = {
  install(app: App): void {
    app.directive('safe-href', (el: HTMLElement, binding: DirectiveBinding) => {
      el.setAttribute('href', sanitizeUrl(binding.value))
    })
  },
}

export default vueSafeHrefPlugin
